export const PRODUCTION = import.meta.env.VITE_PRODUCTION === 'true';
export const ENABLE_SENTRY = import.meta.env.VITE_ENABLE_SENTRY === 'true';
export const YOUTUBE_API_KEY = PRODUCTION
    ? import.meta.env.VITE_YOUTUBE_API_KEY_PROD
    : import.meta.env.VITE_YOUTUBE_API_KEY_DEV;
export const SENTRY_DSN = PRODUCTION
    ? import.meta.env.VITE_SENTRY_DSN_PROD
    : import.meta.env.VITE_SENTRY_DSN_DEV;
export const API_URL = `${import.meta.env.VITE_API_URL}/v2`;

// Ximi SSO (OIDC)
// Masqué par défaut : on n'expose le bouton/les routes de connexion Ximi que lorsque le
// SSO est déployé côté Xelya/Ximi. Passer VITE_XIMI_LOGIN_ENABLED=true au build pour activer.
export const XIMI_LOGIN_ENABLED = import.meta.env.VITE_XIMI_LOGIN_ENABLED === 'true';
export const XIMI_SSO_AUTHORITY = import.meta.env.VITE_XIMI_SSO_AUTHORITY;
export const XIMI_SSO_CLIENT_ID = import.meta.env.VITE_XIMI_SSO_CLIENT_ID;

// Dev-only Skip button: QA test account pre-fill (empty outside dev).
export const XIMI_TEST_QA_TENANT_CODE = import.meta.env.VITE_XIMI_TEST_QA_TENANT_CODE;
export const XIMI_TEST_QA_LOGIN_HINT = import.meta.env.VITE_XIMI_TEST_QA_LOGIN_HINT;

// MobileAPI Ozmo (résolution user post-SSO). Base URL seule ; le path est
// construit côté store. QA path = `/<app>/api/<suffix>` où <app> = partie app du
// tenantCode, points→slashes, tenant exclu (ex. `Master.XimiIndep/xmob` → `Master/XimiIndep`).
export const XIMI_MOBILE_API_URL = import.meta.env.VITE_XIMI_MOBILE_API_URL;

// Native custom URL scheme (Capacitor app id) — used for native deep-link redirects.
// Must match the scheme registered in iOS (Info.plist) / Android (intent-filter).
export const NATIVE_APP_SCHEME = 'fr.stimulin';

// App device: ANDROID | IOS | PWA | WEB | SW
export const DEVICE = (() => {
    if (import.meta.env.VITE_APP_KIND === 'ANDROID') {
        return 'ANDROID';
    }

    if (import.meta.env.VITE_APP_KIND === 'IOS') {
        const metaElement = document?.querySelector('meta[name="viewport"]');
        if (metaElement) {
            metaElement.setAttribute(
                'content',
                'user-scalable=no, width=device-width, initial-scale=1, maximum-scale=5, viewport-fit=cover'
            );
        }
        return 'IOS';
    }

    if (typeof document !== 'undefined' && sessionStorage.getItem('isPWA')) {
        return 'PWA';
    }

    if (typeof document === 'undefined') {
        return 'SW';
    }

    return 'WEB';
})();
